module.exports = __webpack_public_path__ + "img/google-play-store.f195f349.svg";